import * as yup from "yup";
import { isValidCNPJ } from "../../utils/validators";
export var reclamationSchema = yup.object({
    category: yup.string().required("Campo obrigatório"),
    companyName: yup.string().required("Campo obrigatório"),
    cnpj: yup
        .string()
        .optional()
        .test("cnpj", "CNPJ inválido", function (v) { return !v || isValidCNPJ(v); }),
    involvedValue: yup.string().optional(),
    eventDate: yup.string().required("Campo obrigatório"),
    eventLocation: yup.string().optional(),
    description: yup
        .string()
        .required("Campo obrigatório")
        .min(50, "Mínimo de 50 caracteres"),
    possibleSolution: yup
        .string()
        .required("Campo obrigatório")
        .min(50, "Mínimo de 50 caracteres"),
    files: yup.mixed().optional(),
});
